import { Core } from "@faire/design-tokens";
import { FiniteCarouselBase } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Carousel/ByType/FiniteCarouselBase";
import { BaseCarouselProps } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Carousel/CarouselBase";
import { Context } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
import { SearchIconPillStyles } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/styles/SearchIconPillStyles";
import { PAGE_TYPE } from "@faire/retailer-visitor-shared/consts/PAGE_TYPE";
import { localizedUrlWithQueryParams } from "@faire/retailer-visitor-shared/lib/pathUtils";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";
import { Search } from "@faire/web/slate/icons/foundation/Search";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { ILayoutElementData } from "@faire/web-api--source/indigofair/data/ILayoutElementData";
import { ISearchQueryTile } from "@faire/web-api--source/indigofair/data/ISearchQueryTile";
import { ISearchRequestReferrer } from "@faire/web-api--source/indigofair/data/ISearchRequestReferrer";
import React from "react";

export const SearchIconPills: React.FC<BaseCarouselProps> = () => {
  const { layoutElement, onItemClick, requestId, pageType } =
    React.useContext(Context);

  const renderItem = (item: ISearchQueryTile, index: number) => {
    if (!item.query || !item.cta_link) {
      return null;
    }

    const pillLink = item.cta_link;
    const link =
      pageType === PAGE_TYPE.HOMEPAGE
        ? localizedUrlWithQueryParams(pillLink, {
            refType:
              ISearchRequestReferrer.SearchRequestReferrerType
                .HOMEPAGE_RECENT_SEARCHES,
            refReqId: requestId,
          })
        : pillLink;

    const onClick = () => {
      if (layoutElement.on_click_event_name) {
        const queryWithReplacedSpaces = item.query?.replace(/\s/g, "_");
        const token = item.description
          ? `${queryWithReplacedSpaces}|${index}|${item.description}`
          : `${queryWithReplacedSpaces}|${index}`;
        onItemClick?.(layoutElement.on_click_event_name, requestId, token);
      }
    };

    return (
      <React.Fragment key={`${item.query}_${index}`}>
        <SearchIconPillStyles.Pill linkTo={link} onClick={onClick}>
          <Search />
          <Spacer width="2x" />
          <SearchIconPillStyles.TextWrapper>
            <Typography>{item.query}</Typography>
            {item.description ? (
              <Typography variant="labelSansRegular" color={Core.text.subdued}>
                {item.description}
              </Typography>
            ) : null}
          </SearchIconPillStyles.TextWrapper>
        </SearchIconPillStyles.Pill>
      </React.Fragment>
    );
  };

  const getItems = () => {
    return layoutElement.layout_element_data
      .map((elementData: ILayoutElementData) => elementData.search_query_tile)
      .filter(isNotUndefined);
  };

  const items = getItems();
  return <FiniteCarouselBase renderItem={renderItem} items={items} />;
};
